import Welcome from './components/Welcome';

export const Home = () => {
    return (
        <div>
            <Welcome />
        </div>
    )
}
